import { z } from "zod";

export const pendingSettingsSchema = z
  .object({
    pendingDate: z.date().nullish(),
    notify: z.boolean().nullish(),
    enabled: z.boolean(),
  })
  .refine((data) => !(data.enabled && !data.pendingDate), {
    message: "pendingDate is required if pending settings are enabled",
    path: ["pendingDate"],
  });

export type PendingSettings = z.infer<typeof pendingSettingsSchema>;
